export const useIsSmallDevice = () => {
	return window.innerWidth < 1366;
};
